export const timelineSelector = state => state.timeline;
